import { render, staticRenderFns } from "./glovo_export.vue?vue&type=template&id=b5661484&scoped=true&"
import script from "./glovo_export.vue?vue&type=script&lang=js&"
export * from "./glovo_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5661484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5661484')) {
      api.createRecord('b5661484', component.options)
    } else {
      api.reload('b5661484', component.options)
    }
    module.hot.accept("./glovo_export.vue?vue&type=template&id=b5661484&scoped=true&", function () {
      api.rerender('b5661484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/glovo/glovo_export.vue"
export default component.exports